import { htmlUrls } from '@shared/utils/router-paths';
import { MatSnackBar } from "@angular/material/snack-bar";
import { CanActivateFn, Router } from "@angular/router";
import { LocalRepository } from "@shared/helper/local-repository";
import { roleGuard } from "./role.guard";
import { inject } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';


export const BloggerGuard: CanActivateFn = (): boolean => {

    const repo: LocalRepository = inject(LocalRepository);
    const jwtHelper: JwtHelperService = inject(JwtHelperService);
    const router: Router = inject(Router);
    const _snackBar: MatSnackBar = inject(MatSnackBar);
    const result = roleGuard(repo, jwtHelper, ['blogger'], 1);
    if (!result) {
        _snackBar.open("شما به این صفحه دسترسی ندارید.", undefined, {
            duration: 3000,
            panelClass: 'custom-snackbar'
        });
        router.navigate([htmlUrls.feed]);
    }
    return result;
}
